import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GcTextComponent } from '@ip-only/front-end-library';
import { VideoInstruction } from '../video-instruction.entities';

@Component({
  selector: 'app-video-instruction-card',
  imports: [GcTextComponent],
  templateUrl: './video-instruction-card.component.html',
  styleUrl: './video-instruction-card.component.scss',
})
export class VideoInstructionCardComponent {
  private readonly sanitizer: DomSanitizer;

  constructor() {
    this.sanitizer = inject(DomSanitizer);
  }
  instruction = input.required<VideoInstruction>();

  safeEmbedUrl = computed<SafeResourceUrl>(() =>
    this.sanitizer.bypassSecurityTrustResourceUrl(this.instruction().url),
  );
}
